<div class="flex flex-col min-h-screen w-full">
  <app-lite-hero-section></app-lite-hero-section>
  <main class="flex-1 w-full">
    <app-lite-detail-section></app-lite-detail-section>
    <app-lite-flow-event></app-lite-flow-event>
    <app-lite-tournament-section></app-lite-tournament-section>
    <app-lite-flow-tournament></app-lite-flow-tournament>
    <app-lite-good-section></app-lite-good-section>
    <app-lite-testimonial-section></app-lite-testimonial-section>
    <app-lite-interest-section></app-lite-interest-section>
  </main>
  <app-footer></app-footer>
</div>
